var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoardroom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M170.61,89.61a11.92,11.92,0,1,1-11.92-12A12,12,0,0,1,170.61,89.61Zm-47.39,37a11.92,11.92,0,1,1-11.92-12A12,12,0,0,1,123.22,126.62Zm13.17,46v-8.74A16.52,16.52,0,0,0,120,147.31H101.9a16.52,16.52,0,0,0-16.42,16.53v8.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M125,95.73v-7c0-7.35-4.22-13.37-9.39-13.37H105.22c-5.16,0-9.39,6-9.39,13.37v7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 110.79,
    cy: 53.51,
    r: 10.55
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M150.18,139.94h23.73V124.58h0a14.93,14.93,0,0,0-15.11-14,15.18,15.18,0,0,0-13.74,8.5m-83-41.48a12,12,0,1,1-11.92,12A12,12,0,0,1,62.07,77.6Zm13.66,41.48A15.18,15.18,0,0,0,62,110.58a14.93,14.93,0,0,0-15.11,14h0v15.36H70.58M66.67,164.1l16.2-65.19h55.85l15.63,65.24"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoardroom);
export default __webpack_public_path__ + "static/media/BOARDROOM.b9a455eecb970d84ec85ce544cf19952.svg";
export { ForwardRef as ReactComponent };